export default {
  header: "Order a Pizza",
  view: "Order"
};
